import { render, staticRenderFns } from "./VSelectWithValidation.vue?vue&type=template&id=1bec222f&"
import script from "./VSelectWithValidation.vue?vue&type=script&lang=ts&"
export * from "./VSelectWithValidation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports